import ApiManager from "../api/ApiManager";
import { API_KEY, CONFIG_URL } from "../constants";

class ConfigurationManager {
  constructor() {
    this.configuration = undefined;
    this.manager = new ApiManager();
  }

  async getConfiguration() {
    if (this.configuration == undefined) {
      let res = await this.manager.get(CONFIG_URL, API_KEY);
      this.configuration = res.data;
      return this.configuration;
    } else {
      return this.configuration;
    }
  }
}

export default new ConfigurationManager();
